import { Injectable, inject } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { GroupedAutocompleteOptions } from '../../../shared/dto/grouped-autocomplete-options.model';
import { Params } from '@angular/router';
import { EventsAllData, EventModel, ListEventPayload } from '../models/event.model';
import { EventsApiService } from './events-api.service';

@Injectable({
  providedIn: 'root',
})
export class EventsDataService {
  private eventsApiService = inject(EventsApiService);

  getData(entityId: string, params: Params = null): Observable<EventsAllData> {
    const event$: Observable<EventModel> = entityId
      ? this.eventsApiService.get(entityId)
      : of(null);
    const events$: Observable<ListEventPayload> = params
      ? this.eventsApiService.getAll(params)
      : of(null);

    return forkJoin([event$, events$]).pipe(
      map(([event, events]) => ({
        event,
        events,
      }))
    );
  }

  getListData(params?: Params): Observable<Partial<EventsAllData>> {
    const events$: Observable<ListEventPayload> = params
      ? this.eventsApiService.getAll(params)
      : of(null);

    return forkJoin([events$]).pipe(
      map(([events]: [ListEventPayload]) => ({
        events,
      }))
    );
  }

  getSuggestionsList(term: string): Observable<GroupedAutocompleteOptions[]> {
    return this.eventsApiService.getSuggestions(term);
  }

  updateFeModelToBeModel(data: EventModel): EventModel {
    Object.keys(data).forEach(key => {
      if (typeof data[key] === 'string') {
        data[key] = data[key].trim();
      }
      if (data[key] === '') {
        data[key] = null;
      }
    });
    return data;
  }
}
